import React, { useState } from "react";

import { IconButton, TableRow, TableCell, Typography } from "@material-ui/core";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";

import { AccessByCategory } from "./types";
import { EntitlementAccess } from "./EntitlementAccess";

type AccessCatgoryProps = {
  category: AccessByCategory;
  expand: boolean;
  onEntitlementAccessChange: (entitlement_id: string, checked: boolean) => void;
};

export const CategoryAccess = ({
  category,
  expand,
  onEntitlementAccessChange,
}: AccessCatgoryProps) => {
  const [open, setOpen] = useState<boolean>(
    category.has_category_access || expand
  );

  return (
    <>
      <TableRow
        key={`destination-access-row-${category.id}`}
        className={category.has_category_access ? "bg-blue-100" : "bg-gray-100"}
      >
        <TableCell>
          <Typography variant="h4">{category.category}</Typography>
        </TableCell>
        <TableCell align="right"></TableCell>
        <TableCell align="right" width="5%">
          <IconButton
            aria-label="expand row"
            size="small"
            className="focus:outline-none"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
      </TableRow>
      {open && (
        <EntitlementAccess
          key={`entitlement-access-row-${category.entitlements.length}`}
          entitlements={category.entitlements}
          onRowAccessChange={onEntitlementAccessChange}
        />
      )}
    </>
  );
};
